const SectionSingleSeatSelect = {
  order: Infinity,
  run($$) {
    const seatClickHandler = (e) => {
      const $seat = $(e.target);
      const seatAttr = $seat.attr.bind($seat);
      const seatData = $seat.data();

      if (!$$.selectionFilter(seatData)) {
        return;
      }

      // look for a seat item
      const seat = $$.seats[`${seatData.row}-${seatData.coll}`];
      if (!seat) {
        return;
      }

      if (seat.selected) {
        $$.deselectSeat(seatData.row, seatData.coll);
      } else {
        $$.selectSeat(seatData.row, seatData.coll);
      }
    };

    $$.$arena.on("click", seatClickHandler);
  },
};

window.SectionSingleSeatSelect = SectionSingleSeatSelect;

export default SectionSingleSeatSelect;
